import { db } from '../FirebaseLibrary';

export const createStaffsReference = (teamId: string) => {
    return db.collection(`teams/${teamId}/staffs`);
};

export const createStaffReference = (teamId: string, staffId: string) => {
    return createStaffsReference(teamId).doc(staffId);
};

export const fetchStaffFirestoreAPI = (teamId: string, staffId: string) => {
    return createStaffReference(teamId, staffId).get();
};

export const fetchStaffsFirestoreAPI = (teamId: string) => {
    return createStaffsReference(teamId).where('teamId', '==', teamId).where('alumni', '==', false).where('deleted', '==', false)
        .orderBy('order', 'desc')
        .orderBy('timeCreated')
        .get();
};

export const fetchStaffsWithoutOrderFirestoreAPI = (teamId: string) => {
    return createStaffsReference(teamId).where('teamId', '==', teamId).where('alumni', '==', false).where('deleted', '==', false)
        .orderBy('timeCreated')
        .get();
};
